import { Link } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

/*
[
    {title, url}
]
*/
function BreadCrumbs({ crumbs, handleClick = () => {} }) {
  const createCurrentPage = (item) => {
    return item?.action ? (
      <div className="bread_crumbs_ancestor">
        <div onClick={handleClick}>
          <span className="underline cursor-pointer">{item.title}</span>
        </div>
      </div>
    ) : (
      <span>{item.title}</span>
    );
  };

  const createAncestorPage = (item) => {
    return (
      <div className="bread_crumbs_ancestor">
        <Link to={item.to} state={item.state} onClick={handleClick}>
          <span className="underline">{item.title}</span>
        </Link>
      </div>
    );
  };

  return (
    <div className="breadcrumbs text-base hidden sm:block">
      <ul>
        {crumbs.map((item, index) => (
          <li key={uuidv4()}>
            {index === crumbs.length - 1 || !item.to ? createCurrentPage(item) : createAncestorPage(item)}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default BreadCrumbs;
